module.exports = __webpack_public_path__ + "img/rain_heavy.bd48faa0.svg";